const SETTINGS_TAB_KEY_ACCOUNT = "SETTINGS_TAB_KEY_ACCOUNT";
const SETTINGS_TAB_KEY_SITE = "SETTINGS_TAB_KEY_SITE";
const SETTINGS_TAB_KEY_DEVICE = "SETTINGS_TAB_KEY_DEVICE";
const SETTINGS_TAB_KEY_DATA = "SETTINGS_TAB_KEY_DATA";
const SETTINGS_TAB_KEY_PAYMENTS = "SETTINGS_TAB_KEY_PAYMENTS";
const SETTINGS_TAB_KEY_PRIVACY_AND_TERMS = "SETTINGS_TAB_KEY_PRIVACY_AND_TERMS";

const SETTINGS_TAB_KEYS = {
  ACCOUNT: SETTINGS_TAB_KEY_ACCOUNT,
  SITE: SETTINGS_TAB_KEY_SITE,
  DEVICE: SETTINGS_TAB_KEY_DEVICE
  // ,
  // DATA: SETTINGS_TAB_KEY_DATA
  // ,
  // PAYMENTS: SETTINGS_TAB_KEY_PAYMENTS,
  // PRIVACY_AND_TERMS: SETTINGS_TAB_KEY_PRIVACY_AND_TERMS
};

const SETTINGS_TAB_LABELS = {
  [SETTINGS_TAB_KEY_ACCOUNT]: "settings.account",
  [SETTINGS_TAB_KEY_SITE]: "settings.site",
  [SETTINGS_TAB_KEY_DEVICE]: "settings.device"
  // ,
  // [SETTINGS_TAB_KEY_DATA]: "settings.data"
  // ,
  // [SETTINGS_TAB_KEY_PAYMENTS]: "settings.payments",
  // [SETTINGS_TAB_KEY_PRIVACY_AND_TERMS]: "settings.privacyAndTerms"
};

const SETTINGS_ACCOUNT_ACCESS_ADMIN = "SETTINGS_ACCOUNT_ACCESS_ADMIN";
const SETTINGS_ACCOUNT_ACCESS_VIEW_ONLY = "SETTINGS_ACCOUNT_ACCESS_VIEW_ONLY";

const SETTINGS_ACCOUNT_ACCESSES = {
  ADMIN: SETTINGS_ACCOUNT_ACCESS_ADMIN,
  VIEW_ONLY: SETTINGS_ACCOUNT_ACCESS_VIEW_ONLY
};

const SETTINGS_ACCOUNT_ACCESS_LABELS = {
  [SETTINGS_ACCOUNT_ACCESS_ADMIN]: "Admin",
  [SETTINGS_ACCOUNT_ACCESS_VIEW_ONLY]: "View-only"
};

const SETTINGS_ACCOUNT_STATUS_ACTIVE = "SETTINGS_ACCOUNT_STATUS_ACTIVE";
const SETTINGS_ACCOUNT_STATUS_DEACTIVATED = "SETTINGS_ACCOUNT_STATUS_DEACTIVATED";

const SETTINGS_ACCOUNT_STATUS = {
  ACTIVE: SETTINGS_ACCOUNT_STATUS_ACTIVE,
  DEACTIVATED: SETTINGS_ACCOUNT_STATUS_DEACTIVATED
};

const SETTINGS_ACCOUNT_STATUS_LABELS = {
  [SETTINGS_ACCOUNT_STATUS_ACTIVE]: "Active",
  [SETTINGS_ACCOUNT_STATUS_DEACTIVATED]: "Deactivated"
};

const SETTINGS_DATA_TAB_WHOLE_SITE = "SETTINGS_DATA_TAB_WHOLE_SITE";
const SETTINGS_DATA_TAB_ZONES = "SETTINGS_DATA_TAB_ZONES";
const SETTINGS_DATA_TAB_SUMMARY = "SETTINGS_DATA_TAB_SUMMARY";
const SETTINGS_DATA_TAB_CIRCUITS = "SETTINGS_DATA_TAB_CIRCUITS";
const SETTINGS_DATA_TAB_DATA_SOURCE = "SETTINGS_DATA_TAB_DATA_SOURCE";
const SETTINGS_DATA_TAB_DEMAND = "SETTINGS_DATA_TAB_DEMAND";
const SETTINGS_DATA_TAB_TARIFF = "SETTINGS_DATA_TAB_TARIFF";
const SETTINGS_DATA_TAB_DLC = "SETTINGS_DATA_TAB_DLC";
const SETTINGS_DATA_TAB_METERS = "SETTINGS_DATA_TAB_METERS";
const SETTINGS_ZONE_CONFIGURATION_GENERAL = "SETTINGS_ZONE_CONFIGURATION_GENERAL";

const SETTINGS_DATA_TABS = {
  WHOLE_SITE: SETTINGS_DATA_TAB_WHOLE_SITE,
  ZONES: SETTINGS_DATA_TAB_ZONES,
  SUMMARY: SETTINGS_DATA_TAB_SUMMARY,
  CIRCUITS: SETTINGS_DATA_TAB_CIRCUITS,
  DATA_SOURCE: SETTINGS_DATA_TAB_DATA_SOURCE,
  DEMAND: SETTINGS_DATA_TAB_DEMAND,
  TARIFF: SETTINGS_DATA_TAB_TARIFF,
  DLC:SETTINGS_DATA_TAB_DLC,
  METERS:SETTINGS_DATA_TAB_METERS,
  ZONECONFIGURATIONGENERAL:SETTINGS_ZONE_CONFIGURATION_GENERAL
};

const SETTINGS_DATA_TAB_LABELS = {
  SETTINGS_DATA_TAB_WHOLE_SITE: "settings.data.tab.whole.site",
  SETTINGS_DATA_TAB_ZONES: "settings.data.tab.zones",
  SETTINGS_DATA_TAB_SUMMARY: "settings.data.tab.summary",
  SETTINGS_DATA_TAB_CIRCUITS: "settings.data.tab.circuits",
  SETTINGS_DATA_TAB_DATA_SOURCE: "settings.data.tab.data.source",
  SETTINGS_DATA_TAB_DEMAND: "settings.data.tab.demand",
  SETTINGS_DATA_TAB_TARIFF: "settings.data.tab.tariff",
  SETTINGS_DATA_TAB_DLC: "settings.data.tab.DLC",
  SETTINGS_DATA_TAB_METERS:"settings.data.tab.meters",
  SETTINGS_ZONE_CONFIGURATION_GENERAL:"settings.zone.tab.configurationGeneral"
};

const SETTINGS_DATA_SOURCE_TYPE_NET_IMPORT = "netImport";
const SETTINGS_DATA_SOURCE_TYPE_GENERATED = "generated";
const SETTINGS_DATA_SOURCE_TYPE_CONSUMED = "consumed";
const SETTINGS_DATA_SOURCE_TYPE_STORAGE = "storage";
const SETTINGS_DATA_SOURCE_TYPE_SUMMARY = "summary";

const SETTINGS_DATA_SOURCE_TYPES = {
  NET_IMPORT: SETTINGS_DATA_SOURCE_TYPE_NET_IMPORT,
  GENERATED: SETTINGS_DATA_SOURCE_TYPE_GENERATED,
  CONSUMED: SETTINGS_DATA_SOURCE_TYPE_CONSUMED,
  STORAGE: SETTINGS_DATA_SOURCE_TYPE_STORAGE
};

const SETTINGS_DATA_SOURCE_TYPES_ARRAY = Object.values(SETTINGS_DATA_SOURCE_TYPES);

const SETTINGS_DATA_SOURCE_TYPES_COLORS = {
  [SETTINGS_DATA_SOURCE_TYPE_NET_IMPORT]: "#BAA6CA",
  [SETTINGS_DATA_SOURCE_TYPE_GENERATED]: "#B7DCFA",
  [SETTINGS_DATA_SOURCE_TYPE_CONSUMED]: "#FFE69A",
  [SETTINGS_DATA_SOURCE_TYPE_STORAGE]: "#A3D6A5",
  [SETTINGS_DATA_SOURCE_TYPE_SUMMARY]: "#FBBF2D"
};

// Match property names of the ZoneDataSourceRecord
const SETTINGS_DATA_SOURCE_TYPE_PROP_NAMES = {
  [SETTINGS_DATA_SOURCE_TYPE_NET_IMPORT]: "netImportList",
  [SETTINGS_DATA_SOURCE_TYPE_GENERATED]: "generatedList",
  [SETTINGS_DATA_SOURCE_TYPE_CONSUMED]: "consumedList",
  [SETTINGS_DATA_SOURCE_TYPE_STORAGE]: "storageList"
};

const SETTINGS_DATA_SOURCE_TYPE_LABELS = {
  [SETTINGS_DATA_SOURCE_TYPE_NET_IMPORT]: "settings.data.type.net.import",
  [SETTINGS_DATA_SOURCE_TYPE_GENERATED]: "settings.data.type.generated",
  [SETTINGS_DATA_SOURCE_TYPE_CONSUMED]: "settings.data.type.consumed",
  [SETTINGS_DATA_SOURCE_TYPE_STORAGE]: "settings.data.type.storage"
};

const SETTINGS_DATA_SOURCE_TYPE_PURE_LABELS = {
  [SETTINGS_DATA_SOURCE_TYPE_NET_IMPORT]: "Net Import",
  [SETTINGS_DATA_SOURCE_TYPE_GENERATED]: "Generated",
  [SETTINGS_DATA_SOURCE_TYPE_CONSUMED]: "Consumed",
  [SETTINGS_DATA_SOURCE_TYPE_STORAGE]: "Storage"
};

export {
  SETTINGS_TAB_KEY_ACCOUNT,
  SETTINGS_TAB_KEY_SITE,
  SETTINGS_TAB_KEY_DEVICE,
  SETTINGS_TAB_KEY_DATA,
  SETTINGS_TAB_KEY_PAYMENTS,
  SETTINGS_TAB_KEY_PRIVACY_AND_TERMS,
  SETTINGS_TAB_KEYS,
  SETTINGS_TAB_LABELS,
  SETTINGS_ACCOUNT_ACCESSES,
  SETTINGS_ACCOUNT_ACCESS_LABELS,
  SETTINGS_ACCOUNT_STATUS,
  SETTINGS_ACCOUNT_STATUS_LABELS,
  SETTINGS_DATA_TABS,
  SETTINGS_DATA_TAB_LABELS,
  SETTINGS_DATA_SOURCE_TYPES,
  SETTINGS_DATA_SOURCE_TYPES_ARRAY,
  SETTINGS_DATA_SOURCE_TYPE_PROP_NAMES,
  SETTINGS_DATA_SOURCE_TYPE_LABELS,
  SETTINGS_DATA_SOURCE_TYPE_PURE_LABELS,
  SETTINGS_DATA_SOURCE_TYPES_COLORS,
  SETTINGS_DATA_SOURCE_TYPE_SUMMARY
};
